import type { KambiSportName } from '@mobi/api-types/kambi'
import { toTitleCase } from '@mobi/utils/string'
import { keys } from '@core/Services/Analytics/keys'
import { trackEvent } from '@core/Services/Analytics/track'

export const trackFavouriteAdded = (data: Data) => {
  _trackFavouritesEvent({ interaction_type: 'Favourite Added', ...data })
}

export const trackFavouriteRemoved = (data: Data) => {
  _trackFavouritesEvent({ interaction_type: 'Favourite Removed', ...data })
}

export const trackFavouriteUsed = (data: Data) => {
  _trackFavouritesEvent({ interaction_type: 'Favourite Selected', ...data })
}

// =============
// Local Helpers
// =============

const defaultAnalyticsData: Record<keyof FavouriteEventData, undefined> = {
  raceCode: undefined,
  meetingName: undefined,
  sportCode: undefined,
  marketType: undefined,
  competition: undefined,
}

function _trackFavouritesEvent(data: { interaction_type: string } & Data) {
  if (data.sportCode) {
    data.sportCode = toTitleCase(data.sportCode.replaceAll('_', ' ')) as KambiSportName
  }
  if (data.meetingName) {
    data.meetingName = toTitleCase(data.meetingName)
  }
  trackEvent(keys.favourites, { ...defaultAnalyticsData, ...data })
}

// =====
// Types
// =====

type FavouriteEventData = {
  raceCode: string
  meetingName: string

  sportCode: KambiSportName
  competition: string
  marketType: string
}

type Data = Partial<FavouriteEventData>
